'use es6';

import { makePermissionComponent } from 'ecosystem-marketplace-core/components/permissions';
import { gate } from 'hub-http/gates';
import { createSelector } from 'reselect';
import { debugGate } from '../utils/env';
const getPortal = state => state.auth.portal;
const getUser = state => state.auth.user;
const getGates = state => state.auth.gates;
export const getIsUngated = createSelector([getGates], gates => name => gates.includes(name) || debugGate(name));
export const getIsCustomer = createSelector([getPortal], portal => !!(portal && portal.portal_id));

// TODO update if public fetches auth info
// TODO account for admin preview
export const getIsPublic = createSelector([getIsCustomer], isCustomer => !isCustomer);
export const PublicOnly = makePermissionComponent(getIsPublic);
export const getUserFirstName = createSelector([getUser, getIsPublic], (user, isPublic) => isPublic ? null : user.first_name);
export const getUserLastName = createSelector([getUser, getIsPublic], (user, isPublic) => isPublic ? null : user.last_name);
export const getUserEmail = createSelector([getUser], user => user.email);
export const getUserId = createSelector([getUser], user => user.user_id);
const getUserScopes = createSelector([getUser], user => user.scopes);
const getHasScope = createSelector([getUserScopes], scopes => scope => scopes.includes(scope));
export const getHasZorseChatScope = createSelector([getHasScope], hasScope => hasScope('zorse-chat'));
export const getHasZorseWebticketScope = createSelector([getHasScope], hasScope => hasScope('zorse-webticket'));
export const getPortalScopes = createSelector([getPortal], portal => portal.scopes);
export const getIsUngatedForRecommendationsBadge = createSelector([getIsUngated], isUngated => {
  return isUngated('Marketplace:Apps:recommendations-badge');
});
export const getIsUngatedForRecategorization = createSelector([getIsUngated, getIsPublic], (isUngated, isPublic) => {
  if (isPublic) {
    return true;
  }
  return isUngated(gate('Marketplace:Apps:Recategorization')) || debugGate('Marketplace:Apps:Recategorization');
});
export const getIsUngatedForReviewEditing = createSelector([getIsUngated], isUngated => isUngated(gate('Marketplace:Apps:ReviewEditing')));
export const getIsUngatedForSearchbarUpdates = createSelector([getIsUngated], isUngated => isUngated(gate('Marketplace:Apps:searchbar-updates')));